"use client";

import { useCallback } from "react";
import { useTrackLeadFormEvent } from "./useTrackLeadFormEvent";

interface UseTrackedStepAdvanceOptions {
  analyticsStepName?: string;
  analyticsUserSelection?: Record<string, string | string[]>;
  onContinue: () => void;
}

/**
 * Returns a stable callback that fires the "Lead Form Step" analytics event
 * (when analyticsStepName is provided) and then calls onContinue. Shared by
 * ContinueButton's click handler and the keyboard-advance action a step
 * registers via useRegisterKeyboardStepAction, so both paths emit identical
 * analytics for the same step.
 */
function useTrackedStepAdvance({
  analyticsStepName,
  analyticsUserSelection,
  onContinue,
}: UseTrackedStepAdvanceOptions): () => void {
  const trackLeadForm = useTrackLeadFormEvent();

  return useCallback(() => {
    if (analyticsStepName) {
      trackLeadForm?.leadFormStep({
        stepName: analyticsStepName,
        userSelection: analyticsUserSelection,
      });
    }
    onContinue();
  }, [analyticsStepName, analyticsUserSelection, onContinue, trackLeadForm]);
}

export { useTrackedStepAdvance };
